<script lang="ts" setup>
    import { vMaska } from "maska/vue";
    import type { MaskInputOptions } from "maska";
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const regleField =
        orderStore.validation.r$.$fields.toggleableFields.donation;

    const donation = ref("0");
    onMounted(() => {
        donation.value = (
            (orderStore.currentOrder.toggleableFields.donation ?? 0) / 100
        )
            .toFixed(2)
            .toString();
    });

    const donationMask = reactive<MaskInputOptions>({
        onMaska: (value) => {
            if (!isNaN(parseFloat(value.unmasked))) {
                orderStore.currentOrder.toggleableFields.donation =
                    parseFloat(value.unmasked) * 100;
            }
        },
        number: {
            locale: "nl",
            fraction: 2,
            unsigned: true,
        },
    } as MaskInputOptions);
</script>

<template>
    <shared-labeled-field
        v-if="orderStore.options.toggleableFields.donation?.enabled"
        v-slot="{ ariaLabelledby }"
        :label="
            $t('checkout.donation.label') +
            (orderStore.options.toggleableFields.donation.required ? ' *' : '')
        "
    >
        <VTextField
            v-model="donation"
            v-maska="donationMask"
            :aria-labelledby="ariaLabelledby"
            :placeholder="$t('checkout.donation.placeholder')"
            :error-messages="regleField?.$errors"
            @focusout="regleField?.$touch"
        >
            <template #prepend-inner> € </template>
        </VTextField>
    </shared-labeled-field>
</template>
